<template>
  <table class="table table-borderless table-align table-h51">
    <thead>
      <tr>
        <th>ID</th>
        <th>Conta</th>
        <th>Placa</th>
        <th>Renavam</th>
        <th>CNPJ</th>
        <th>Protocolo</th>
        <th>Documento</th>
        <th>GRU</th>
        <th>Status</th>
        <th>Situação</th>
        <th>Status da análise</th>
        <th>Emitido em</th>
        <th>Valido até</th>
        <th>Criado em</th>
        <th>Atualizado em</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="chronotachograph in chronotachographHistories" :key="chronotachograph.id">
        <td>{{ chronotachograph.id }}</td>
        <td>{{ getAccountName(chronotachograph) }}</td>
        <td>{{ chronotachograph.plate }}</td>
        <td>{{ chronotachograph.renavam }}</td>
        <td>{{ chronotachograph.cnpj }}</td>
        <td>{{ chronotachograph.protocol }}</td>
        <td>{{ chronotachograph.documentNumber }}</td>
        <td>{{ chronotachograph.gruNumber }}</td>
        <td>{{ chronotachograph.documentStatus  }}</td>
        <td>{{ chronotachograph.situation  }}</td>
        <td>{{ chronotachograph.analysisStatus | analysisStatus }}</td>
        <td>{{ chronotachograph.issuedAt | date }}</td>
        <td>{{ chronotachograph.validAt | date }}</td>
        <td>{{ chronotachograph.createdAt | datetime }}</td>
        <td>{{ chronotachograph.updatedAt | datetime }}</td>
        <td>

          <div class="btn-group">
            <router-link
              v-if="linkRequest"
              :to="`/admin/maestro/requests/${chronotachograph.requestId}`"
              class="btn btn-outline"
            >
              Requisição
            </router-link>

            <router-link
              v-if="linkChronotachograph && chronotachograph.chronotachographId"
              :to="`/admin/maestro/chronotachographs/${chronotachograph.chronotachographId}`"
              class="btn btn-outline"
            >
              Multa
            </router-link>

            <router-link
              :to="`/admin/maestro/chronotachograph_histories/${chronotachograph.id}`"
              class="btn btn-outline"
            >
              Ver
            </router-link>
          </div>
        </td>
      </tr>
      </tbody>
  </table>
</template>

<script>
import { Translate } from '@/services/Translate'

export default {
  filters: {
    statusChronotachograph(status) {
      return Translate(`chronotachograph.${status}`)
    },
    analysisStatus(status) {
      return {
        not_analyzed: 'Não analisado',
        analyzing: 'Em análise',
        analyzed: 'Analisado',
      }[status]
    }
  },
  inject: ['getAccountName'],
  name: 'Table',
  props: {
    chronotachographHistories: { required: true, type: Array },
    linkRequest: { default: false, type: Boolean },
    linkChronotachograph: { default: false, type: Boolean },
  }
}

</script>

<style scoped>

</style>